/* global window */

import './style.scss';

import React from 'react';
import { trackNow } from 'shared/models/analytic';

class TextToDownload extends React.Component {
  constructor(props) {
    super(props);
    this.sms = this.sms.bind(this);
  }

  sms(event) {
    event.preventDefault();
    var phone = this.phoneInput.value;
    var linkData = {
      channel: 'Website',
      feature: 'TextMeTheApp'
    };
    if (window.branch) {
      window.branch.sendSMS(phone, linkData, {}, function(error) {
        console.log(error); // eslint-disable-line no-console
      });
    }
    trackNow('Text Me the App', {
      path: window.location.pathname,
      section: this.props.section
    });
    this.phoneInput.value = '';
  }

  render() {
    const className = ['text-to-download', this.props.className || ''].join(
      ' '
    );

    return (
      <div className={className}>
        <div className="row">
          <div className="col-xs-12 text">
            Enter your number &amp; we’ll text you a download link
          </div>
          <div className="col-xs-12">
            <form className="input-group" onSubmit={this.sms}>
              <span className="input-group-addon">+1</span>
              <input
                id="phone-input"
                name="phone"
                type="tel"
                ref={input => (this.phoneInput = input)}
                className="form-control field-icon field-btn"
                placeholder="(123) 456-7890"
              />
              <span className="input-group-btn">
                <button type="submit" className="input-btn">
                  Send
                </button>
              </span>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default TextToDownload;



// WEBPACK FOOTER //
// ./shared/components/textToDownload/index.js